/* __next_internal_client_entry_do_not_use__ ImageUploader auto */ import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Core } from "@faire/design-tokens";
import { Typography } from "@faire/web--source/slate/Typography";
import * as React from "react";
import { ImageUploaderDropzone } from "./ImageUploaderDropzone";
import { useImageUploaderState } from "./useImageUploaderState";
/**
 * @trackcomponent
 * @link [Docs](https://web-docs.faire.team/slate/ImageUploader)
 */ export var ImageUploader = function(param) {
    var onFileUpload = param.onFileUpload, onUploadError = param.onUploadError, currentImage = param.currentImage, uploadCta = param.uploadCta, height = param.height, width = param.width, maxFileSize = param.maxFileSize, circular = param.circular, _param_externallyManagedReupload = param.externallyManagedReupload, externallyManagedReupload = _param_externallyManagedReupload === void 0 ? false : _param_externallyManagedReupload, _param_error = param.error, error = _param_error === void 0 ? false : _param_error, displayRestrictions = param.displayRestrictions;
    var imageUploaderState = useImageUploaderState(onFileUpload);
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsx(ImageUploaderDropzone, {
                externallyManagedReupload: externallyManagedReupload,
                currentImage: currentImage,
                onImageUpload: imageUploaderState.handleImageUpload,
                onUploadError: onUploadError ? onUploadError : imageUploaderState.setErrorMessage,
                uploadCta: uploadCta,
                error: !!imageUploaderState.errorMessage || error,
                loading: !!imageUploaderState.loading,
                height: height,
                width: width,
                maxFileSize: maxFileSize,
                circular: circular,
                displayRestrictions: displayRestrictions
            }),
            imageUploaderState.errorMessage ? /*#__PURE__*/ _jsx(Typography, {
                color: Core.text.critical,
                children: imageUploaderState.errorMessage
            }) : null
        ]
    });
};
